import { PartnerDetails, PartnerTypes } from 'apis/PartnerApi';

export const DEFAULT_PARTNER: PartnerDetails = {
    Active: true,
    Address1: '',
    Address2: '',
    City: '',
    ContactEmail: '',
    Country: { Id: 0, Name: '' },
    CustomerIds: '',
    CustomerIDString: '',
    DateCreate: new Date(), // Getting set by db proc
    DateModified: new Date(), // Getting set by db proc
    DisabledDetailsBtn: false,
    IconURL: '',
    ID: 0,
    Id: 0,
    Language: { Id: 0, Name: '' },
    Name: '',
    OperatingCountries: [],
    PartnerType: PartnerTypes.SuperAdmin, //This gets changed immediately when moved to create form.
    Phone: '',
    Policy: '',
    Sector: null,
    SectorName: '',
    State: { Id: 0, Name: '' },
    StateID: 0,
    UserEmailList: '',
    Zip: ''
};